import React from "react";

// 8-pointed star SVG motif matching the RKS Systems logo mark
// (two overlapping squares rotated 45° — Rub el Hizb / Star of Lakshmi shape).
// Optionally renders a label (e.g. "RKS") centered inside the polygon.
export function StarMotif({
    className = "",
    strokeWidth = 0,
    fill = "currentColor",
    label,
    labelColor = "#ffffff",
}) {
    return (
        <svg viewBox="0 0 100 100" className={className} aria-hidden="true" role="presentation">
            <polygon
                points="50,5 63,18 82,18 82,37 95,50 82,63 82,82 63,82 50,95 37,82 18,82 18,63 5,50 18,37 18,18 37,18"
                fill={fill}
                stroke={fill}
                strokeWidth={strokeWidth}
                strokeLinejoin="round"
            />
            {label && (
                <text
                    x="50"
                    y="52"
                    textAnchor="middle"
                    dominantBaseline="central"
                    fill={labelColor}
                    fontFamily="Manrope, sans-serif"
                    fontWeight="800"
                    fontSize="30"
                    letterSpacing="-1"
                >
                    {label}
                </text>
            )}
        </svg>
    );
}

export default StarMotif;
